import { useNavigation, useTranslate } from "@refinedev/core";
import { Button, Card, Col, Result, Row, theme } from "antd";
import { useEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { axiosInstance } from "../../authProvider";

const { useToken } = theme;

const ConfirmEmail = () => {

    const _t = useTranslate();
    const { token } = useToken();
    const { replace } = useNavigation();
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const [params] = useSearchParams();
    const hasCalledApi = useRef(false);

    useEffect(() => {
        const fetchData = async () => {
            const hash = params.get('hash');
            if (hash && !hasCalledApi.current) {
                hasCalledApi.current = true;
                setLoading(true);
                try {
                    await axiosInstance.post('/auth/email/confirm', { hash });
                    setSuccess(true);
                } catch (error) {
                    setSuccess(false);
                } finally {
                    setLoading(false);
                }
            }
        };
        fetchData();
    }, [params]);

    return (
        <>
            < Row
                justify="center" align="middle" style={{ minHeight: '100vh', backgroundColor: token.colorBgLayout }}
            >
                <Col className="sm:w-100 md:w-1/2">
                    <Card className="mt-16 text-center" style={{ backgroundColor: token.colorBgContainer, borderColor: token.colorBorder }}>
                        {loading ? (
                            <Result
                                status="info"
                                title="Confirming email..."
                                subTitle="Please wait while we confirm your email address."
                            />
                        ) : success ? (
                            <Result
                                status="success"
                                title={_t('pages.register.confirmEmailMessage')}
                                subTitle={_t('pages.register.confirmEmailSubMessage')}
                            />
                        ) : (
                            <Result
                                status="error"
                                title={_t('pages.register.confirmEmailErrorMessage')}
                                subTitle={_t('pages.register.confirmEmailErrorSubMessage')}
                            />
                        )}
                        <Button
                            type="primary"
                            onClick={() => replace("/login")}
                        >
                            {_t('pages.register.gotoLoginMessage')}
                        </Button>
                    </Card>
                </Col>
            </Row>
        </>
    );
}

export default ConfirmEmail;
